import Vue from 'vue';

export default {
  state: {
    inboundStatuses: [],
  },
  getters: {
    callCenterInboundStatuses(state) {
      return state.inboundStatuses.filter(item => item.type_id === 1);
    },
  },
  mutations: {
    SET_INBOUND_STATUSES(state, payload) {
      state.inboundStatuses = payload;
    },
  },
  actions: {
    GET_INBOUND_STATUSES(context) {
      return Vue.axios.get('inbound_statuses/active').then((response) => {
        context.commit('SET_INBOUND_STATUSES', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/inbound_statuses.js